<template>
  <div class="sequences u-flex" v-if="currentSequence">
    <div class="sequences__item u-relative" v-for="(theme, index) in themes" :class="{'is-active': index === currentSequence.lorealEnvironentIndex}">
      <div class="sequences__item__bar" :style="{width: sequenceWidth + 'px'}" />
      <div class="sequences__item__title" >
        {{ envData[theme].name }}
      </div>
    </div>
  </div>
</template>

<script>
const baseWidth = 80
const baseMarg = 10

import envData from '@/assets/data/environments'

export default {
  data () {
    return {
      envData: envData
    }
  },
  computed: {
    themes () {
      return this.$store.getters['data/themes']
    },
    currentSequence () {
      return this.$store.getters['data/sequenceBySlug'](this.$route.params.sequence)
    },
    sequenceWidth () {
      const halfScreen = this.$device.width * .5
      const totalMarg = baseMarg * (this.themes.length - 1)

      const baseTotalWidth = baseWidth * this.themes.length + totalMarg

      if (baseTotalWidth < halfScreen) {
        return baseWidth
      }
      else {
        return (halfScreen - totalMarg) / this.themes.length
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.sequences
  max-width 50%
  
  &__item    
    margin-right 10px

    &:last-child
      margin-right 0

    &__bar
      transform scale(1, .6)
      opacity .7
      transition transform .3s linear
      background-color: $colors.white
      border-radius: 5px
      height 10px
      
    &.is-active &__bar
      transform scale(1, 1)
      opacity 1
    
    &__title
      position absolute
      top 20px
      left 50%
      transform translate3s(-50%, -10px, 0)
      opacity 0
      transition transform .3s ease-in-out-quad, opacity .3s linear
      text-align center
      width 300px
      pointer-event none

    &.is-active &__title
      transform translateX(-50%)
      opacity 1
      
      
</style>